import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import meltdownImage from './assets/meltdown.png';
import SubmissionPage from './SubmissionPage';
import PrivacyPolicy from './PrivacyPolicy';
import FreeBeerPage from './FreeBeerPage';
import FreeBurgerPage from './FreeBurgerPage';
import ChargingPage from './ChargingPage';
import { trackEvent } from './analytics';

function Home() {
  const [activeTab, setActiveTab] = React.useState('youtube');

  const platforms = {
    youtube: {
      name: 'YouTube',
      logo: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      ),
      embed: (
        <iframe
          width="100%"
          height="500"
          src={`https://www.youtube.com/embed/videoseries?si=t5yy8LVRjH9qKnKm&list=OLAK5uy_nnz5zKudUtncqbfaIQZtX1NeKP6TUHJAg&enablejsapi=1&origin=${window.location.origin}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          style={{ borderRadius: '12px' }}
        ></iframe>
      )
    },
    spotify: {
      name: 'Spotify',
      logo: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm5.508 17.304c-.216.36-.672.468-1.032.252-2.856-1.74-6.444-2.136-10.68-1.164-.408.096-.816-.156-.912-.564-.096-.408.156-.816.564-.912 4.644-1.056 8.64-.612 11.832 1.344.348.204.468.66.228 1.044zm1.476-3.264c-.276.444-.852.588-1.296.312-3.264-2.004-8.232-2.58-12.084-1.416-.504.156-1.032-.144-1.188-.636-.156-.504.144-1.032.636-1.188 4.416-1.344 9.912-.672 13.632 1.62.444.276.588.852.3 1.308zm.132-3.444c-3.912-2.328-10.356-2.544-14.124-1.392-.6.18-1.236-.168-1.416-.768-.18-.6.168-1.236.768-1.416 4.332-1.308 11.436-1.056 15.912 1.608.54.324.72 1.02.396 1.56-.312.552-1.02.72-1.536.408z" />
        </svg>
      ),
      embed: (
        <iframe
          style={{ borderRadius: '12px' }}
          src="https://open.spotify.com/embed/album/33h61NTgMB9snBRfekv8Qa?utm_source=generator"
          width="100%"
          height="500"
          frameBorder="0"
          allowFullScreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          title="Spotify Embed"
        ></iframe>
      )
    },
    apple: {
      name: 'Apple Music',
      logo: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M19.467 11.867c.013-1.893 1.653-2.8 1.707-2.84-.893-1.293-2.28-1.467-2.773-1.493-1.174-.12-2.294.693-2.894.693-.586 0-1.52-.68-2.52-.68-1.284.02-2.48.747-3.134 1.88-1.333 2.307-.346 5.707.947 7.573.64 1.12 1.413 1.933 2.613 1.907 1.16-.027 1.6-.733 3-.733 1.386 0 1.787.733 3.013.707 1.254-.027 1.907-.733 2.667-1.84.894-1.293 1.253-2.547 1.28-2.613-.027-.013-2.454-.947-2.427-3.134zM15.48 5.76c.533-.64.88-1.533.787-2.427-.774.027-1.707.507-2.267 1.16-.494.573-.934 1.48-.814 2.36.88.066 1.76-.454 2.294-1.093z" />
        </svg>
      ),
      embed: (
        <iframe
          allow="encrypted-media *; fullscreen *; clipboard-write"
          frameBorder="0"
          height="500"
          style={{ width: '100%', overflow: 'hidden', borderRadius: '12px' }}
          sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
          src="https://embed.music.apple.com/us/album/meltdown/1875212935"
          title="Apple Music Embed"
        ></iframe>
      )
    }
  };
  const [youtubeKey, setYoutubeKey] = React.useState(0);

  React.useEffect(() => {
    trackEvent('page_view', 'home');
  }, []);

  const handleTabChange = (key) => {
    if (key === 'youtube') {
      setYoutubeKey(prev => prev + 1);
    }
    trackEvent('tab_switch', key);
    setActiveTab(key);
  };

  return (
    <>
      {/* Section 1: Music Embeds */}
      <section className="music-section fade-in">
        <div className="section-header">
          <h3>Latest Music</h3>
        </div>

        <div className="music-tabs-container">
          <div className="music-tabs">
            {Object.keys(platforms).map((key) => (
              <button
                key={key}
                className={`tab-pill ${activeTab === key ? 'active' : ''}`}
                onClick={() => handleTabChange(key)}
                title={platforms[key].name}
              >
                {platforms[key].logo}
                <span>{platforms[key].name}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="active-embed-container">
          <div key={`yt-${youtubeKey}`} style={{ display: activeTab === 'youtube' ? 'block' : 'none' }}>
            {platforms.youtube.embed}
          </div>
          <div style={{ display: activeTab === 'spotify' ? 'block' : 'none' }}>
            {platforms.spotify.embed}
          </div>
          <div style={{ display: activeTab === 'apple' ? 'block' : 'none' }}>
            {platforms.apple.embed}
          </div>
        </div>
      </section>

      {/* Section 2: Thank You Section */}
      <section className="thank-you-section fade-in">
        <h1>Welcome & Thank You!</h1>
        <p>
          Thank you for sharing some of your time checking out my music.<br></br>
          I appreciate you and hope you enjoy!
        </p>
        <p>
          I always look forward to the times I get to create.<br></br>
          I try to make the most of these rare moments.<br></br>
          While I am, I don't often consider what will happen after I'm done.<br></br>
          As a result of this, most things are left frozen in time.
        </p>
        <p className="highlight-text">
          I'd love to hear what you're working on. Submit your songs/instrumentals below.
        </p>
      </section>

      {/* Section 3: Submissions CTA */}
      <section className="submission-cta-section fade-in">
        <div className="submit-cta-container">
          <h4>Producer / Instrumental Artist?</h4>
          <p>I'm always looking for new sounds. Submit your instrumentals below.</p>
          <Link to="/submit" className="submit-cta-btn">Submit Your Beats</Link>
        </div>
      </section>

      {/* Section 4: About Artist */}
      <section className="about-section fade-in">
        <div className="about-artist">
          <div className="card-header">
            <h2>About Da Kid Dru</h2>
          </div>
          <div className="card-body">
            <p>Mexican-American dude from Vallejo, California. I've been messing around with music for like 15 years. It's not ok. Sometimes this shit slaps. I love it. It's passionately toxic. I don't endorse it. I'd like to apologize in advance for my actions.</p>
            <p>I believe in building beauty in this world. Sometimes, shit gets ugly. I'm an advocate for education, even when the systems fail us. Please go to college, it's never too late. I got your back.</p>
            <p>Whatever you're doing out there, I hope it brings you happiness without causing more despair.</p>
          </div>
        </div>
        <div className="photo-placeholder">
          <img src={meltdownImage} alt="Meltdown Album Art" style={{ maxWidth: '100%', height: 'auto', borderRadius: '12px' }} />
        </div>
      </section>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/submit" element={
            <>
              <div className="nav-header">
                <Link to="/" className="back-link">
                  ← Back to Music
                </Link>
              </div>
              <SubmissionPage />
            </>
          } />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/free_beer" element={<FreeBeerPage />} />
          <Route path="/free_burger" element={<FreeBurgerPage />} />
          <Route path="/charging" element={<ChargingPage />} />
        </Routes>

        {/* Row 3: Footer */}
        <footer className="app-footer">
          <div className="footer-column">
            <h5>Contact</h5>
            <p>bookings@musicfc.com</p>
          </div>

          <div className="footer-column">
            <h5>Support</h5>
            <a
              href="https://ko-fi.com/dakiddru"
              target="_blank"
              rel="noopener noreferrer"
              className="tip-link"
              onClick={() => trackEvent('external_click', 'kofi_tip')}
            >
              <span>☕</span> Tip the Artist
            </a>
          </div>

          <div className="footer-column">
            <h5>Social</h5>
            <div className="social-media">
              <a href="https://instagram.com/dakiddru" target="_blank" rel="noopener noreferrer" className="social-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-bottom">
            <Link to="/privacy" className="privacy-link">Privacy Policy</Link>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;